module.exports = __webpack_public_path__ + "static/media/AlexanderPopov.f38de15b.jpg";